export default function PageNotFound() {
	return <div className="flex items-center h-[100vh] font-bold text-greenTurquoise">404 - PAGE NOT FOUND</div>;
}
